import { useState } from "react";
import axios from "axios";
import "./Payment.css";

function Payment() {
	
	const [book] = useState({
		price: 5,
		name1: "StackOverflow - Free Plan",
		author1: "Chhuti Mistry",
		img1: "https://cdn.sstatic.net/Sites/stackoverflow/Img/favicon.ico?v=ec617d715196",
		price1: 10,
		name2: "StackOverflow - Silver Plan",
		author2: "Chhuti Mistry",
		img2: "https://cdn.sstatic.net/Sites/stackoverflow/Img/favicon.ico?v=ec617d715196",
		price2: 100,
		name3: "StackOverflow - Gold Plan",
		author3: "Chhuti Mistry",
		img3: "https://cdn.sstatic.net/Sites/stackoverflow/Img/favicon.ico?v=ec617d715196",
		price3: 1000
	});

	const initPayment = (data) => {

		const options = {
			key: "rzp_test_ZsdUPzZgg7EFLB",
			amount: data.amount,
			currency: data.currency,
			name: book.name,
			description: "Test Transaction",
			image: book.img,
			order_id: data.id,
			redirect: true,

			handler: async (response) => {
				try {
					const verifyUrl = "https://stackoverflow-razorpayserver.onrender.com/api/payment/verify";
					const { data } = await axios.post(verifyUrl, response);
					console.log(data);
				} catch (error) {
					console.log(error);
				}
			},
			theme: {
				color: "#3399cc",
			},
		};
		const rzp1 = new window.Razorpay(options);
		rzp1.open();
	};

	const handlePayment = async () => {
		try {
			const orderUrl = "https://stackoverflow-razorpayserver.onrender.com/api/payment/orders";
			const { data } = await axios.post(orderUrl, { amount: book.price });
			console.log(data);
			initPayment(data.data);
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="Appp">
			<div className="book_containerp">
				<img src={book.img1} alt="book_img" className="book_imgp" />
				<p className="book_namep">{book.name1}</p>
				<p className="book_authorp">By {book.author1}</p>
				<p className="book_pricep">
					Price : <span>&#x20B9; {book.price1}</span>
				</p>
				<button onClick={handlePayment} className="buy_btnp">
					buy now
				</button>
			</div>
			<div className="book_containerp">
				<img src={book.img2} alt="book_img" className="book_imgp" />
				<p className="book_namep">{book.name2}</p>
				<p className="book_authorp">By {book.author2}</p>
				<p className="book_pricep">
					Price : <span>&#x20B9; {book.price2}</span>
				</p>
				<button onClick={handlePayment} className="buy_btnp">
					buy now
				</button>
			</div>
			<div className="book_containerp">
				<img src={book.img3} alt="book_img" className="book_imgp" />
				<p className="book_namep">{book.name3}</p>
				<p className="book_authorp">By {book.author3}</p>
				<p className="book_pricep">
					Price : <span>&#x20B9; {book.price3}</span>
				</p>
				<button onClick={handlePayment} className="buy_btnp">
					buy now
				</button>
			</div>
		</div>
	);
}

export default Payment;